import { ReactComponent as Sparkle } from "assets/icons/Sparkle.svg"
import { times } from "lodash-es"
import s from "./Sparkles.module.scss"

export const Sparkles = () => {
  const NUMBER_OF_STARS = 10 // Manually adjusted in CSS file

  return times(NUMBER_OF_STARS, (index) => (
    <Sparkle className={s.sparkle} key={index} />
  ))
}
